import * as betprofessor from './OverviewAccordion.styles.betprofessor';
import * as betroyale from './OverviewAccordion.styles.betroyale';
import * as fiestabet from './OverviewAccordion.styles.fiestabet';
import * as goldenrush from './OverviewAccordion.styles.goldenrush';
import * as juicybet from './OverviewAccordion.styles.juicybet';
import * as puntcity from './OverviewAccordion.styles.puntcity';
import * as puntgenie from './OverviewAccordion.styles.puntgenie';
import * as questbet from './OverviewAccordion.styles.questbet';
import * as sterlingparker from './OverviewAccordion.styles.sterlingparker';
import * as vikingbet from './OverviewAccordion.styles.vikingbet';
import * as volcanobet from './OverviewAccordion.styles.volcanobet';
import * as wellbet from './OverviewAccordion.styles.wellbet';
import * as forsport from './OverviewAccordion.styles.forsport';
import * as junglebet from './OverviewAccordion.styles.junglebet';
import * as betgalaxy from './OverviewAccordion.styles.betgalaxy';
import * as oldgill from './OverviewAccordion.styles.oldgill';
import * as sugarcastle from './OverviewAccordion.styles.sugarcastle';
import * as buffalobet from './OverviewAccordion.styles.buffalobet';
import * as titanbet from './OverviewAccordion.styles.titanbet';
import * as slambet from './OverviewAccordion.styles.slambet';
import * as gigabet from './OverviewAccordion.styles.gigabet';
import * as betstride from './OverviewAccordion.styles.betstride';
import * as templebet from './OverviewAccordion.styles.templebet';
import * as goldenbet888 from './OverviewAccordion.styles.goldenbet888';
import * as hyperbet from './OverviewAccordion.styles.hyperbet';
import * as bet777 from './OverviewAccordion.styles.bet777';
import * as chromabet from './OverviewAccordion.styles.chromabet';
import * as bet575 from './OverviewAccordion.styles.bet575';
import * as betblast from './OverviewAccordion.styles.betblast';
import * as pyramidbet from './OverviewAccordion.styles.pyramidbet';
import * as magnumbet from './OverviewAccordion.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  betgalaxy,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
